export default __webpack_public_path__ + "static/media/upload2.b34be2b0.svg";